import { render, staticRenderFns } from "./MyCollectionCard.vue?vue&type=template&id=7b3311cd&scoped=true&lang=pug"
import script from "./MyCollectionCard.vue?vue&type=script&lang=js"
export * from "./MyCollectionCard.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionCard.vue?vue&type=style&index=0&id=7b3311cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3311cd",
  null
  
)

export default component.exports